<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t1">14 Beats—No Breath</span></p>
<p class="p0">By David Connor and E.F. Mulder</p>
<p class="p2"><a id="a3"></a> </p>
<p class="p2"><a href="#/006#a18">Chapter 1</a></p>
<p class="p2"><a href="#/007#a19">Chapter 2</a></p>
<p class="p2"><span href="#/008#a20" title="Link target outside of Sample">Chapter 3</span></p>
<p class="p2"><span href="#/009#a21" title="Link target outside of Sample">Chapter 4</span></p>
<p class="p2"><span href="#/010#a22" title="Link target outside of Sample">Chapter 5</span></p>
<p class="p2"><span href="#/011#a23" title="Link target outside of Sample">Chapter 6</span></p>
<p class="p2"><span href="#/012#a24" title="Link target outside of Sample">Chapter 7</span></p>
<p class="p2"><span href="#/013#a25" title="Link target outside of Sample">Chapter 8</span></p>
<p class="p2"><span href="#/014#a26" title="Link target outside of Sample">Chapter 9</span></p>
<p class="p2"><span href="#/015#a27" title="Link target outside of Sample">Chapter 10</span></p>
<p class="p2"><span href="#/016#a28" title="Link target outside of Sample">Epilogue</span><a href="#/#a17"></a></p>
<h1 class="h10"><a id="ncx38"></a><a id="a17"></a> </h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?beca41a6